import React, { useRef } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import { IoMdSearch } from "react-icons/io";
import { TbPlus } from "react-icons/tb";

import styles from "@areas/shared/pages/personal/frames/statistics/contracts/blocks/styles/allTable.module.css";

function Table({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  onSearch,
  onCreateRequest,
}) {
  const searchRef = useRef(); 
  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };
  const nameCellStyle = {
    maxWidth: "60ch",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    lineHeight: 1.3,
  };
  const compactCellStyle = {
    maxWidth: "14ch",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Код</span>,
      selector: (row) => row.Id,
      sortable: true,
      width: "12ch",
      grow: 0,
      cell: (row) => (
        <span style={compactCellStyle} title={row.Id}>
          {row.Id}
        </span>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">ИНН</span>,
      selector: (row) => row.Inn,
      sortable: true,
      width: "12ch",
      grow: 0,
      cell: (row) => (
        <span style={compactCellStyle} title={row.Inn}>
          {row.Inn}
        </span>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">КПП</span>,
      selector: (row) => row.Kpp, 
      sortable: true,
      width: "12ch",
      grow: 0,
      cell: (row) => (
        <span style={compactCellStyle} title={row.Kpp}>
          {row.Kpp}
        </span>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Наименование</span>,
      selector: (row) => row.Shortname ? row.Shortname : row.Fullname,
      sortable: true,
      width: "70ch",
      grow: 0,
      cell: (row) => (
        <span style={nameCellStyle}>
          {row.Shortname ? row.Shortname : row.Fullname}
        </span>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      grow: 0,
      center: true,
      compact: true,
      cell: (row) => {
        return (
          <div className="d-flex flex-wrap gap-1 justify-content-center">
            <button
              type="button"
              className="btn btn-outline-success btn-sm d-flex align-items-center"
              title="Создать заявку"
              onClick={() => onCreateRequest(row)}
            >
              <TbPlus size={16} />
            </button>
            <Link
              to={`/personal/requests/list-to?idCompany=${row.Id}`}
              className="btn btn-outline-primary btn-sm"
              title="Входящие заявки"
            >
              Входящие
            </Link>
            <Link
              to={`/personal/requests/list-from?idCompany=${row.Id}`}
              className="btn btn-outline-primary btn-sm"
              title="Исходящие заявки" 
            >
              Исходящие
            </Link>
          </div>
        );
      },
    },
  ];

  const submitSearch = () => {
    onSearch(searchRef.current.value);
  };

  return (
    <>
      <div className={styles.search}>
        <input
          type="text"
          placeholder="Поиск по наименованию или ИНН"
          ref={searchRef}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submitSearch();
            }
          }}
        />
        <div
          className={`btn btn-outline-secondary ${styles.btn}`}
          onClick={submitSearch}
        >
          <IoMdSearch size={25} />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        progressComponent={<ClipLoader />}
        progressPending={load}
        paginationTotalRows={total}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pagination
        paginationServer
        paginationComponentOptions={paginationOptions}
      />
    </>
  );
}

export default Table;
